export default __webpack_public_path__ + "static/media/0_upper_right.9a132881.svg";